import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appTableRow]',
    standalone: false
})
export class  TableRowDirective {

  @HostBinding('class')
  className = 'app-table-row';
}
